import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  padding: 0;
  margin-left: 40px;
  margin-top: 200px;
  margin-bottom: 50px;
  min-height: calc(100vh - 250px);

  ${media.medium`
    display: inline-flex;
    flex-direction: column;
    margin: 10vw 0 0 20%;
    padding: 10px 0 18vw 0;
  `}
`;
